/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Looks_Great_Continue_To_CheckoutInputs */

const en_looks_great_continue_to_checkout = /** @type {(inputs: Looks_Great_Continue_To_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Looks Great - Continue to Checkout`)
};

const es_looks_great_continue_to_checkout = /** @type {(inputs: Looks_Great_Continue_To_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se ve genial - Continuar al Pago`)
};

const fr_looks_great_continue_to_checkout = /** @type {(inputs: Looks_Great_Continue_To_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superbe - Continuer vers le Paiement`)
};

const de_looks_great_continue_to_checkout = /** @type {(inputs: Looks_Great_Continue_To_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sieht toll aus - Weiter zur Kasse`)
};

const ja_looks_great_continue_to_checkout = /** @type {(inputs: Looks_Great_Continue_To_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`素晴らしいですね - チェックアウトに進む`)
};

const zh_looks_great_continue_to_checkout = /** @type {(inputs: Looks_Great_Continue_To_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`看起来不错 - 继续结账`)
};

const ar_looks_great_continue_to_checkout = /** @type {(inputs: Looks_Great_Continue_To_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يبدو رائعًا - المتابعة للدفع`)
};

const id_looks_great_continue_to_checkout = /** @type {(inputs: Looks_Great_Continue_To_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terlihat Bagus - Lanjutkan ke Pembayaran`)
};

const it_looks_great_continue_to_checkout = /** @type {(inputs: Looks_Great_Continue_To_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sembra Perfetto - Vai al Checkout`)
};

const ru_looks_great_continue_to_checkout = /** @type {(inputs: Looks_Great_Continue_To_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выглядит Отлично — Перейти к Оплате`)
};

const pt_looks_great_continue_to_checkout = /** @type {(inputs: Looks_Great_Continue_To_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Está Ótimo - Continuar para o Checkout`)
};

const ko_looks_great_continue_to_checkout = /** @type {(inputs: Looks_Great_Continue_To_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`완벽합니다 - 결제 단계로 이동`)
};

/**
* | output |
* | --- |
* | "Looks Great - Continue to Checkout" |
*
* @param {Looks_Great_Continue_To_CheckoutInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const looks_great_continue_to_checkout = /** @type {((inputs?: Looks_Great_Continue_To_CheckoutInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Looks_Great_Continue_To_CheckoutInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_looks_great_continue_to_checkout(inputs)
	if (locale === "es") return es_looks_great_continue_to_checkout(inputs)
	if (locale === "fr") return fr_looks_great_continue_to_checkout(inputs)
	if (locale === "de") return de_looks_great_continue_to_checkout(inputs)
	if (locale === "ja") return ja_looks_great_continue_to_checkout(inputs)
	if (locale === "zh") return zh_looks_great_continue_to_checkout(inputs)
	if (locale === "ar") return ar_looks_great_continue_to_checkout(inputs)
	if (locale === "id") return id_looks_great_continue_to_checkout(inputs)
	if (locale === "it") return it_looks_great_continue_to_checkout(inputs)
	if (locale === "ru") return ru_looks_great_continue_to_checkout(inputs)
	if (locale === "pt") return pt_looks_great_continue_to_checkout(inputs)
	return ko_looks_great_continue_to_checkout(inputs)
});